import FormCard from "../../../../components/FormCard";
import FormRow from "../../../../components/FormRow";
import FormInput from "../../../../components/FormInput";
import Dropdown from "../../../../components/Dropdown";
import Button from "../../../../components/Button";
import SmallerSpinner from "../../../../components/SmallerSpinner";
import ImageDropzone from "../../../../components/ImageDropzone";
import DatePicker from "../../../../components/DatePicker";
import styles from "../css/ecoControlFridges.module.css";

export default function AddFridgeForm({
  showAddFridge,
  binNumber,
  temperature,
  serialNumber,
  supplier,
  totalQty,
  uploadFile,
  itemName,
  sku,
  batch,
  qty,
  unity,
  expiry,
  roleId,
  onBinNumberChange,
  onTemperatureChange,
  onSerialNumberChange,
  onSupplierChange,
  onTotalQtyChange,
  onUploadFileChange,
  onItemNameChange,
  onSkuChange,
  onBatchChange,
  onQtyChange,
  onUnityChange,
  onExpiryChange,
  onCancel,
  onAddToFridge
}) {
  if (!showAddFridge) return null;

  return (
    <div className={styles.addContainer}>
      {/* Fridge Details Card */}
      <FormCard className={styles.smallCard}>
        <div className={styles.cardHeaderRow}>
          <h3 className={styles.cardTitle}>Fridge Details</h3>
        </div>

        <div className={styles.twoColGrid}>
          <div className={styles.leftCol}>
            <FormRow>
              <FormInput label="Bin Number" value={binNumber} onChange={onBinNumberChange} />
            </FormRow>
            <FormRow>
              <FormInput label="Temperature °C" value={temperature} onChange={onTemperatureChange} />
            </FormRow>
            <FormRow>
              <FormInput label="Fridge Serial Number" value={serialNumber} onChange={onSerialNumberChange} />
            </FormRow>
            <FormRow>
              <Dropdown name="supplier" label="Supplier" options={["1"]} value={supplier} onChange={onSupplierChange} />
            </FormRow>
          </div>
          <div className={styles.rightCol}>
            <div className={styles.qtyRow}>
              <div className={styles.fieldLabel}>Total Quantity</div>
              <div className={styles.qtyCompact}>
                <SmallerSpinner
                  value={totalQty}
                  onChange={onTotalQtyChange}
                  ariaLabel="Total Quantity"
                  baseWidth={140}
                  style={{ height: 40 }}
                />
              </div>
            </div>
            <div className={styles.uploadBox}>
              <ImageDropzone
                id="fridge-upload"
                name="fridgeUpload"
                accept="image/png,image/jpeg"
                value={uploadFile}
                onChange={onUploadFileChange}
                placeholder="Drop files here"
                helper="Supported format: PNG, JPG"
              />
              <div className={styles.uploadActions}>
                <Button variant="cancel" onClick={onCancel}>Cancel</Button>
                <Button variant="primary">Upload</Button>
              </div>
            </div>
          </div>
        </div>
      </FormCard>

      {/* Add Item to Fridge Card */}
      <FormCard className={styles.smallCard}>
        <div className={styles.cardHeaderRow}>
          <h3 className={styles.cardTitle}>Add Item to Fridge</h3>
        </div>
        <div className={styles.formGrid}>
          <FormInput label="Item Name" placeholder="e.g., Amoxicillin 500mg" value={itemName} onChange={onItemNameChange} />
          <FormInput label="SKU" placeholder="e.g., MED-12345" value={sku} onChange={onSkuChange} />
          <FormInput label="Batch Number" placeholder="e.g., BT-2024-001" value={batch} onChange={onBatchChange} />
          <div style={roleId === 3 ? { display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' } : undefined}>
            <div className={styles.fieldLabel}>Quantity</div>
            <div className={styles.qtyCompact} style={roleId === 3 ? { transform: 'none', marginTop: 10 } : undefined}>
              <SmallerSpinner
                value={qty}
                onChange={onQtyChange}
                ariaLabel="Quantity"
                compact={roleId === 3 ? false : undefined}
                className={roleId === 3 ? styles.pageSpinnerFix : undefined}
                baseWidth={140}
                style={{ height: 40 }}
                btnStyle={{ position: 'relative', top: '8px', transform: 'translateY(8px)' }}
              />
            </div>
          </div>
          <Dropdown name="unity" label="Unity" placeholder="Select unity" options={[
            'Vials','Injections','Syringes','Box','Pack','Bottle'
          ]} value={unity} onChange={onUnityChange} />
          <div>
            <div className={styles.fieldLabel}>Expiry Date</div>
            <DatePicker selectedDate={expiry} onDateChange={onExpiryChange} />
          </div>
        </div>
        <div className={styles.footerActions}>
          <Button variant="primary" onClick={onAddToFridge}>Add to Fridge</Button>
        </div>
      </FormCard>
    </div>
  );
}

